export default class DataGridHeaderOptions {
  constructor(
    public filter: boolean,
    public sort: boolean,
    public sortThirdClickReset: boolean = true,
    public setCellHeaderProps?: any
  ) {}
}
